import { IdentityDocument } from '../components';
import { useIdentityDocument } from '../hooks';
import { useOnboardingContext } from '../hooks/useOnboardingContext';
import { PageComponentProps } from '../types';

export const IdentityDocumentStep = ({ canGoBack }: PageComponentProps) => {
  const {
    initialValues,
    submitLoading,
    submitDisabled,
    files,
    goToBack,
    onSubmit,
    onAddFiles,
    onRemoveFile,
  } = useIdentityDocument();

  const { step } = useOnboardingContext();

  return (
    <IdentityDocument
      canGoBack={canGoBack}
      files={files}
      initialValues={initialValues}
      step={step}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      onAddFiles={onAddFiles}
      onGoBack={goToBack}
      onRemoveFile={onRemoveFile}
      onSubmit={onSubmit}
    />
  );
};
